import React, { PureComponent } from 'react';
import { Container, Header } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Svg from 'react-inlinesvg';
import {
  CompareResults,
  Disclaimer,
  PageHeader,
  SearchResultsPlaceholder,
  TotalPill,
  Wrappers
} from '../components';
import { FilterForm } from '../forms';
import { Formatters } from '../utils';
import { compose, graphql } from 'react-apollo';
import { default as getObjectProperty } from 'lodash.get';
import { withPageViewTracking, withAnalytics } from '../analytics';
import { Queries, getApiStatus, getApiError } from '../api';
import { TOOLS } from '../constants';
import { LEARNING_PAGE } from '../constants';
import { screenImageBG, refreshIcon } from '../images';

/*
 TODO: This is less than ideal, we're double-querying the endpoint right now
 we should fix that later for performance.
 */
const CompareToolLastUpdatedView = ({ lastUpdated }) => {
  if (lastUpdated) {
    return (
      <time className="text--nowrap">
        <Svg src={refreshIcon} />
        <FormattedMessage
          id="description.date"
          description="Description of date"
          defaultMessage="Last updated on {date}"
          values={{ date: Formatters.date(lastUpdated) }}
        />
      </time>
    );
  }

  return null;
};

CompareToolLastUpdatedView.propTypes = {
  lastUpdated: PropTypes.string
};

const CompareToolLastUpdated = compose(
  graphql(Queries.getLastUpdated, {
    options: {
      fetchPolicy: 'cache-and-network'
    },
    props: props => ({
      ...props,
      lastUpdated: getObjectProperty(props, 'data.lastUpdated', undefined)
    })
  })
)(CompareToolLastUpdatedView);

class CompareTool extends PureComponent {
  state = {
    queryOptions: null,
    selectedProduct: null,
    formActive: true,
    products: null
  };

  static propTypes = {
    analytics: PropTypes.object.isRequired,
    filter: PropTypes.object,
    filterGroups: PropTypes.array,
    filterStatus: PropTypes.string,
    filterError: PropTypes.string
  };

  updateResults = productIDs => {
    this.setState({ products: productIDs });
  };

  // for mobile
  toggleCompareForm = () => {
    window.scrollTo(0, 0);
    this.setState({ formActive: !this.state.formActive });
  };

  onSubmit = values => {
    const { analytics } = this.props;
    // align the data structure to what's expected in BE
    const queryOptions = Object.keys(values).map(key => ({
      key,
      option: { key: values[key] }
    }));

    analytics.trackFormSubmission({
      Tool: TOOLS.PRODUCT_COMPARISON
    });

    this.setState({ formActive: false, queryOptions });
  };

  render() {
    const { filter } = this.props;
    const { queryOptions, selectedProduct, products } = this.state;

    return (
      <Wrappers.Layout menu>
        <Container as="main">
          <PageHeader overlap>
            <Header as="h1" data-qa="product-education-header">
              <small>Learning</small>
              {selectedProduct ? (
                <FormattedMessage
                  id="title.bundle"
                  description="Bundle page title"
                  defaultMessage="Compare bundle options"
                />
              ) : (
                <FormattedMessage
                  id="title.compare"
                  description="Compare Tool page title"
                  defaultMessage="compare grain handling solutions"
                />
              )}
            </Header>
            <CompareToolLastUpdated />
          </PageHeader>

          <FilterForm {...filter} onHandleSubmit={this.onSubmit} />

          {products && <TotalPill total={products.length} unit="Result" />}

          {queryOptions && (
            <CompareResults
              queryOptions={queryOptions}
              updateResults={this.updateResults}
              setBundledProduct={this.setBundledProduct}
            />
          )}
          {!queryOptions && (
            <SearchResultsPlaceholder
              header={
                <FormattedMessage
                  id="subtitle.compare_intro"
                  description="Compare Tool page intro title"
                  defaultMessage="Let’s start comparing!"
                />
              }
              images={[screenImageBG, screenImageBG, screenImageBG]}
            >
              <p>
                <FormattedMessage
                  id="description.compare_intro"
                  description="Compare Tool page intro description"
                  defaultMessage="Complete the form on the left to find the handling solutions for your needs."
                />
              </p>
              <Disclaimer
                page={LEARNING_PAGE}
                data-testid="placeholder-disclaimer"
              />
            </SearchResultsPlaceholder>
          )}
        </Container>
      </Wrappers.Layout>
    );
  }
}

export default compose(
  graphql(Queries.productComparisonGroups, {
    options: { fetchPolicy: 'cache-and-network' },
    props: props => ({
      filter: {
        filterGroups: props.data && props.data.getProductComparisonGroups,
        filterStatus: getApiStatus(props),
        filterError: getApiError(props)
      }
    })
  }),
  withAnalytics,
  withPageViewTracking()
)(CompareTool);



// WEBPACK FOOTER //
// ./src/pages/CompareTool.js